import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const TeamEquipmentsContainer = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isActive";
  },
})<{ isActive?: boolean }>(({ isActive }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "4px",
  width: "100%",
  color: isActive ? colors.gray600 : colors.gray400,
}));

export const TeamEquipmentsIcon = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  padding: "8px",
}));

export const TeamEquipments = styled("div", {
  shouldForwardProp(propName) {
    return propName !== "isCentered";
  },
})<{ isCentered?: boolean }>(({ isCentered }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: isCentered ? "center" : undefined,
  gap: "4px",
  width: "100%",
  alignSelf: "stretch",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  padding: "0 4px",
}));
